"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _yourlogohere = _interopRequireDefault(require("../../assets/png/yourlogohere.png"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Logo = function Logo(_ref) {
  var logo = _ref.logo,
    onEdit = _ref.onEdit,
    editable = _ref.editable;
  return /*#__PURE__*/_react.default.createElement(_styled.Container, null, /*#__PURE__*/_react.default.createElement(_styled.Wrapper, null, /*#__PURE__*/_react.default.createElement(_styled.LogoImage, {
    src: logo || _yourlogohere.default
  }), editable && /*#__PURE__*/_react.default.createElement(_styled.EditIcon, {
    onClick: onEdit
  })));
};
Logo.propTypes = {
  onEdit: _propTypes.default.func,
  logo: _propTypes.default.string,
  editable: _propTypes.default.bool
};
Logo.defaultProps = {
  onEdit: _noop.default,
  logo: null,
  editable: false
};
var _default = Logo;
exports.default = _default;